import { render } from "./QuestionFiveView.vue?vue&type=template&id=4716d4fc&scoped=true&ts=true"
import script from "./QuestionFiveView.vue?vue&type=script&lang=ts"
export * from "./QuestionFiveView.vue?vue&type=script&lang=ts"

import "./QuestionFiveView.vue?vue&type=style&index=0&id=4716d4fc&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4716d4fc"]])

export default __exports__